/* eslint-disable prettier/prettier */
<template>
  <div class="mapContainer" :style="{ opacity: !$store.state.isLoading ? '1' : '0' }">
    <PopupAlert
      v-model="showspot"
      :spotMsg="storeMsg"
      type="spot"
      @click:confirm="handleConfirm"
      @click:keep="handleKeep"
    />
    <PopupAlert v-model="showspotFail" type="spotFail" />
    <PopupAlert v-model="showspotNoDistance" type="spotNoDistance" />
    <NavBarMain :is-prev="true" color="white">
      <template #left_icon>
        <img style="width: 30px" class="bell" src="@/assets/images/ic24ArrowL.svg" alt="" />
      </template>
      <template #title>
        <p
          style="
            font-size: 18px;
            font-weight: 500;
            line-height: 21.6px;
            letter-spacing: 0.72px;
            color: black;
          "
        >
          門市踩點
        </p>
      </template>
    </NavBarMain>
    <img v-if="ad" class="adbanner" :src="ad" />
    <div class="content">
      <img class="mapbg" :src="mapBackground" alt="bg" />
      <div class="taiwancontent">
        <div class="mapBody">
          <img @click.stop="resetClick" class="map" :src="map" alt="taiwan" />
          <div
            class="pin"
            :style="[
              {
                left: `${location.positionX}%`,
                top: `${location.positionY}%`,
                zIndex:
                  isClick.index === location.e_storeno && isClick.status ? '100' : `${index + 1}`,
              },
            ]"
            @click="setClick(location.e_storeno)"
            v-for="(location, index) in filterLocations"
            :key="`${index}location`"
          >
            <img
              v-if="isClick.status && isClick.index === location.e_storeno"
              style="width: 36.77px; height: 56px"
              :src="
                location.spotstatus
                  ? require('@/assets/images/pinInClick.png')
                  : require('@/assets/images/pinClick.png')
              "
              alt="pin"
            />
            <img
              v-else
              style="width: 27.57px; height: 42px"
              :src="
                location.spotstatus
                  ? require('@/assets/images/pinIn.png')
                  : require('@/assets/images/pin.png')
              "
              alt="pin"
            />
          </div>
        </div>
      </div>
      <div class="storeList" v-show="filterCity.length > 0">
        <div
          class="city"
          :style="{ padding: !item.spotstatus ? '12px' : '12px 8px 12px 12px' }"
          :class="{ choose: isClick.index === item.e_storeno }"
          @click="setClick(item.e_storeno)"
          v-for="item in filterCity"
          :key="item.name"
          :data-storeno="item.e_storeno"
        >
          <div class="left">
            <div class="name">
              <p>{{ item.e_storename }}</p>
              <p class="detail">
                距離<span>{{ item.distance || '???' }}</span
                >km
              </p>
            </div>
            <div class="loc">
              <img
                style="width: 14px; height: 14px"
                src="@/assets/images/ic24Locationgray.svg"
                alt="地點圖示"
              />
              <p>{{ item.address }}</p>
            </div>
          </div>
          <div
            v-if="!item.spotstatus"
            :class="{ disable: item.distance > 0.5 || !item.distance }"
            @click="spotClick(item.e_storeno, item.longitude, item.latitude, item.distance)"
            class="right"
          >
            踩點
          </div>
          <div class="spot" v-else>
            <img
              style="width: 100%; height: 100%; object-fit: cover"
              src="@/assets/images/spot.png"
              alt=""
            />
            <div class="time force-font-8">
              {{ $dayjs(item.spotTime).format('YYYY.MM.DD') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarMain from '@/components/NavBarMain.vue'
import PopupAlert from '@/components/Popup/PopupAlert.vue'
import { GetMapImage, getAllSpotInfo, checkHasSpot, insertSpotInfo } from '@/apis/api.js'
export default {
  name: 'Home',
  components: {
    NavBarMain,
    PopupAlert,
  },
  data: () => ({
    isImageLoaded: false,
    storeMsg: {},
    showspot: false,
    showspotNoDistance: false,
    showspotFail: false,
    isFinish: false,
    mapBackground: '',
    ad: '',
    map: '',
    winResize: null,
    winDistance: null,
    mapHeight: 0,
    listHeight: 0,
    isClick: {
      status: false,
      index: 0,
    },
    storeInfo: {},
    locations: [
      // {
      //   x: '56%',
      //   y: '4%',
      // },
      // {
      //   x: '46%',
      //   y: '7%',
      // },
      // {
      //   x: '51%',
      //   y: '13%',
      // },
      // {
      //   x: '27%',
      //   y: '32%',
      // },
      // {
      //   x: '23%',
      //   y: '47%',
      // },
      // {
      //   x: '25%',
      //   y: '63%',
      // },
      // {
      //   x: '36%',
      //   y: '63%',
      // },
      // {
      //   x: '31%',
      //   y: '70%',
      // },
      // {
      //   x: '56%',
      //   y: '57%',
      // },
      // {
      //   x: '69%',
      //   y: '18%',
      // },
    ],
  }),
  computed: {
    filterLocations: function () {
      return this.locations.filter(item => item.isenabled).sort((a, b) => a.positionY - b.positionY)
    },
    filterCity: function () {
      // 先嘗試篩選 distance < 0.5 的資料
      let filtered = this.filterLocations.filter(item => item.distance < 0.5)

      // 如果沒有符合的，則篩選 distance < 5000 的資料
      if (filtered.length === 0) {
        filtered = this.filterLocations.filter(item => item.distance < 50)
      }
      filtered = filtered.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance))

      // 找到 isClick.index 指向的物件
      const clickedItemIndex = this.isClick.index
      const clickedItem = this.filterLocations.find(item => item.e_storeno === clickedItemIndex)

      // 確保 isClick 物件存在且不在 filtered 陣列中
      if (clickedItem && !filtered.includes(clickedItem)) {
        let clickArr = []
        clickArr.push(clickedItem)
        return clickArr
      }

      return filtered
    },
  },
  beforeCreate() {
    this.$store.state.isLoading = true
  },
  created() {
    var parent = this
    if (
      !localStorage.getItem('phone') ||
      !localStorage.getItem('password') ||
      !localStorage.getItem('member_no')
    ) {
      parent.$router.push('/login')
    } else {
      parent.memberNo = localStorage.getItem('member_no')
      parent.getSpotStatus()
      parent.loadImage()
    }
  },
  mounted() {
    // setTimeout(() => {
    //   this.$store.state.isLoading = false
    // }, 1000)
    this.setWinResize()
    this.getMapHeight()
    // this.$eventBus.$on('gps-updated', () => {
    //   console.log('GPS 位置已更新')
    //   this.updateDistances()
    // })
    console.log(
      localStorage.getItem('member_no'),
      localStorage.getItem('password'),
      localStorage.getItem('phone')
    )
  },
  beforeUnmount() {
    // 取消事件監聽
    // this.$eventBus.$off('gps-updated')

    // 其他現有代碼...
    this.removeWinResize()
    // this.removeDistance()
  },
  methods: {
    getSpotStatus() {
      const parent = this
      getAllSpotInfo().then(function (rsp) {
        checkHasSpot(localStorage.getItem('phone'), localStorage.getItem('password')).then(
          function (store) {
            const storeMap = new Map(store.data.map(item => [item.e_storeno, item]))
            parent.locations = rsp
              .filter(item => storeMap.has(item.e_storeno))
              .map(item => {
                const storeItem = storeMap.get(item.e_storeno)
                return {
                  ...item,
                  spotstatus: storeItem.spotstatus,
                  spotTime: storeItem.SpotTime,
                }
              })
          }
        )
      })
    },
    handleConfirm() {
      this.$router.push('/info/coupon')
    },
    handleKeep() {
      this.updateDistances()
    },
    spotClick(no, loc, lat, distance) {
      if (!distance) {
        this.showspotNoDistance = true
        return
      }
      if (distance > 0.5) {
        this.showspotFail = true
        return
      }
      insertSpotInfo(
        localStorage.getItem('phone'),
        localStorage.getItem('password'),
        no,
        loc,
        lat
      ).then(rsp => {
        console.log(rsp)
        if (rsp.success) {
          this.getSpotStatus()
          this.showspot = true
          this.storeMsg = rsp.data
        }
      })
    },
    updateDistances() {
      try {
        // const { latitude, longitude } = await this.getCurrentPosition()
        const { latitude, longitude } = this.$receiveGPS
        this.locations = this.locations.map(location => ({
          ...location,
          distance: this.getDistance(
            latitude,
            longitude,
            location.latitude, // 假設目標點有 latitude
            location.longitude // 假設目標點有 longitude
          )?.toFixed(2), // 保留兩位小數
        }))
      } catch (error) {
        console.error('無法獲取位置:', error)
      }
    },
    // getCurrentPosition() {
    //   return new Promise((resolve, reject) => {
    //     if (navigator.geolocation) {
    //       navigator.geolocation.getCurrentPosition(
    //         position => {
    //           resolve({
    //             latitude: position.coords.latitude,
    //             longitude: position.coords.longitude,
    //           })
    //         },
    //         error => {
    //           reject(error)
    //         }
    //       )
    //     } else {
    //       reject(new Error('瀏覽器不支援地理定位'))
    //     }
    //   })
    // },
    getDistance(mylat, mylon, targetlat, targetlon) {
      if (!mylat || !mylon) {
        return
      }
      const R = 6371 // 地球半徑，單位公里
      const toRadians = degrees => degrees * (Math.PI / 180) // 度轉弧度

      const dLat = toRadians(targetlat - mylat) // 緯度差
      const dLon = toRadians(targetlon - mylon) // 經度差

      const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(mylat)) *
          Math.cos(toRadians(targetlat)) *
          Math.sin(dLon / 2) *
          Math.sin(dLon / 2)

      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      const distance = R * c // 距離（公里）

      return distance
    },
    async loadImage() {
      const [background, ad, map] = await Promise.all([
        GetMapImage('Background'),
        GetMapImage('Ad'),
        GetMapImage('Map'),
      ])
      this.mapBackground = background
      this.ad = ad
      this.map = map
      console.log('圖片載入完成')
      this.isImageLoaded = true
    },
    setClick(i) {
      this.isClick.status = true
      this.isClick.index = i

      this.$nextTick(() => {
        const targetElement = document.querySelector(`.city[data-storeno="${i}"]`)
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth', // 平滑滾動
            block: 'center', // 滾動到列表中間
          })
        }
      })
    },
    resetClick() {
      this.isClick.status = false
      this.isClick.index = ''
    },
    setWinResize() {
      this.winResize = this.getMapHeight
      window.addEventListener('resize', this.winResize)
    },
    // setDistance() {
    //   this.winDistance = setInterval(this.updateDistances, 60000)
    // },
    removeWinResize() {
      window.removeEventListener('resize', this.winResize)
    },
    // removeDistance() {
    //   clearInterval(this.winDistance)
    // },
    getMapHeight() {
      const content = document.querySelector('.content')
      const adHeight = document.querySelector('.adbanner')?.getBoundingClientRect().height || 0
      const contentHeight = window.innerHeight - (adHeight + 60)
      content.style.height = `${contentHeight}px`
      console.log('adHeight', adHeight)
      if (this.locations.length > 0) {
        const listHeight = document.querySelector('.storeList').getBoundingClientRect().height
        document.querySelector('.taiwancontent').style.height = `${contentHeight - listHeight}px`
        this.isFinish = true
      }
    },
  },
  watch: {
    isImageLoaded(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.getMapHeight()
          setTimeout(() => {
            this.$store.state.isLoading = false
          }, 1000)
        })
      }
    },
    filterCity() {
      this.$nextTick(() => {
        this.getMapHeight()
      })
    },
    isFinish() {
      if (this.isFinish) {
        this.updateDistances()
        // this.setDistance()
      }
    },
    '$receiveGPS.isStart': {
      handler(newValue) {
        if (newValue) {
          this.updateDistances()
        }
      },
      immediate: true,
    },
    '$receiveGPS.latitude': function () {
      // 確保已經初始化
      if (this.$receiveGPS.isStart) {
        console.log('經度變更')
        this.updateDistances()
      }
    },
    '$receiveGPS.longitude': function () {
      // 確保已經初始化
      if (this.$receiveGPS.isStart) {
        console.log('緯度變更')
        this.updateDistances()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mapContainer {
  display: flex;
  flex-direction: column;
}
.adbanner {
  width: 100%;
  aspect-ratio: 750/180;
  position: relative;
  object-fit: cover;
}
.content {
  margin: 0 !important;
  padding: 0 !important;
  position: relative;
  width: 100%;
  overflow: hidden;
  & .mapbg {
    position: absolute;
    aspect-ratio: 750/1244;
    width: 100%;
    height: 100%;
    inset: 0;
    object-fit: cover;
  }
  & .taiwancontent {
    position: absolute;
    width: 100%;
    height: 100%;
    aspect-ratio: 750/960;
    top: 0;
    & .mapBody {
      position: absolute;
      top: 50%;
      left: 50%;
      height: 90%;
      max-height: 500px;
      transform: translate(-50%, -50%);
      aspect-ratio: 150/192;
      & .map {
        height: 100%;
        object-fit: cover;
      }
      & .pin {
        position: absolute;
        width: 36.77px;
        height: 42px;
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
    }
  }
  & .storeList {
    max-height: 200px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 12px 16px;
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    & .city {
      border: solid 1.5px #f2f2f2;
      background-color: #fffbf5;
      border-radius: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      &.choose {
        border: solid 1.5px #ff9f4b;
      }
      & .left {
        display: flex;
        flex-direction: column;
        gap: 8px;
        & .name {
          font-family: Noto Sans TC;
          font-weight: bold;
          font-size: 18px;
          line-height: 25.2px;
          letter-spacing: 0.72px;
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          align-items: flex-end;
          & .detail {
            font-size: 12px;
            line-height: 19.5px;
            letter-spacing: 1px;
            font-weight: normal;
            color: #909090;
            & span {
              font-weight: 800;
              color: #ff9f4b;
            }
          }
        }
        & .loc {
          font-family: Noto Sans TC;
          font-size: 12px;
          font-weight: normal;
          line-height: 1.2;
          letter-spacing: 0.4px;
          display: flex;
          align-items: center;
          gap: 2px;
          color: #909090;
           & p {
            text-align: start;
           }
        }
      }
      & .right {
        font-family: Noto Sans TC;
        display: flex;
        background-color: #ff9f4b;
        color: #fff;
        box-shadow: -1px 5px 10px -2px #f1913d14, -1px 1px 4px -2px #f1913d1f;
        padding: 9px 23.5px;
        font-weight: bold;
        line-height: 14.4px;
        letter-spacing: 0.48px;
        font-size: 12px;
        border-radius: 8px;
        &.disable {
          background-color: #f2f2f2;
          color: #6f6f6f;
        }
      }
      & .spot {
        position: relative;
        height: 51.2px;
        width: 92px;
        & .time {
          position: absolute;
          top: 39px;
          left: 14px;
          transform: rotate(-10deg);
          font-size: 8px;
          font-weight: bold;
          color: #ff9f4b;
          font-family: Noto Sans TC;
        }
      }
    }
  }
}
</style>
